import styled from 'styled-components'

export const StyledPendingPayment = styled.div`
	font-size: 16px;

	td:first-child {
		font-weight: 600;
		padding-right: 15px;
	}
`
